import React from 'react';
import { Link } from 'react-router-dom';
import styles from './UI.module.css';

/* ── Section Tag ─────────────────────────────────────────── */
export function Tag({ children, light, style }) {
  return (
    <p className={`${styles.tag} ${light ? styles.tagLight : ''}`} style={style}>
      {children}
    </p>
  );
}

/* ── Section Heading ─────────────────────────────────────── */
export function Heading({ children, light, size = 'lg' }) {
  return (
    <h2 className={`${styles.heading} ${styles[`heading--${size}`]} ${light ? styles.headingLight : ''}`}>
      {children}
    </h2>
  );
}

/* ── Lead Paragraph ──────────────────────────────────────── */
export function Lead({ children, light, style }) {
  return (
    <p className={`${styles.lead} ${light ? styles.leadLight : ''}`} style={style}>
      {children}
    </p>
  );
}

/* ── Primary Button ──────────────────────────────────────── */
export function BtnPrimary({ children, to, href, onClick, className = '', style }) {
  const cls = `${styles.btnPrimary} ${className}`;
  if (to)   return <Link to={to} className={cls} style={style}>{children}</Link>;
  if (href) return <a href={href} className={cls} style={style} target="_blank" rel="noreferrer">{children}</a>;
  return <button onClick={onClick} className={cls} style={style}>{children}</button>;
}

/* ── Outline Button ──────────────────────────────────────── */
export function BtnOutline({ children, to, href, download, onClick, light, className = '', style }) {
  const cls = `${styles.btnOutline} ${light ? styles.btnOutlineLight : ''} ${className}`;
  if (to) return <Link to={to} className={cls} style={style}>{children}</Link>;
  if (href) return <a href={href} download={download} className={cls} style={style}>{children}</a>;
  return <button onClick={onClick} className={cls} style={style}>{children}</button>;
}

/* ── Card ─────────────────────────────────────────────────── */
export function Card({ children, className = '', style, onClick }) {
  return (
    <div
      className={`${styles.card} ${className}`}
      style={style}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

/* ── Icon Box ─────────────────────────────────────────────── */
export function IconBox({ children, color = 'blue' }) {
  return (
    <div className={`${styles.iconBox} ${styles[`iconBox--${color}`]}`}>
      {children}
    </div>
  );
}

/* ── Badge / Pill ─────────────────────────────────────────── */
export function Badge({ children, variant = 'default' }) {
  return (
    <span className={`${styles.badge} ${styles[`badge--${variant}`]}`}>
      {children}
    </span>
  );
}

/* ── Section Wrapper ─────────────────────────────────────── */
export function Section({ id, children, variant = 'paper', className = '', style }) {
  return (
    <section
      id={id}
      className={`${styles.section} ${styles[`section--${variant}`]} ${className}`}
      style={style}
    >
      {children}
    </section>
  );
}

/* ── Page Hero Banner ─────────────────────────────────────── */
export function PageHero({ tag, title, subtitle }) {
  return (
    <div className={styles.pageHero}>
      <div className={styles.pageHeroInner}>
        {tag && <Tag light>{tag}</Tag>}
        <h1 className={styles.pageHeroTitle}>{title}</h1>
        {subtitle && <p className={styles.pageHeroSub}>{subtitle}</p>}
      </div>
    </div>
  );
}

/* ── Divider ─────────────────────────────────────────────── */
export function Divider() {
  return <hr className={styles.divider} />;
}

/* ── Check List ──────────────────────────────────────────── */
export function CheckList({ items, light }) {
  return (
    <ul className={styles.checkList}>
      {items.map((item, i) => (
        <li key={i} className={`${styles.checkItem} ${light ? styles.checkItemLight : ''}`}>
          <span className={styles.checkMark}>✓</span>
          {item}
        </li>
      ))}
    </ul>
  );
}
